import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Image,
  Switch,
} from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";

import { useSelector, useDispatch } from "react-redux";
import { fileManagerActions, paymentActions } from "../../store";

import UploadFile from "../../components/UploadFile";
import ENV from "../../consts/config";
import modulesApi from "../../api/module/modulesApi";
import Swal from "sweetalert2";

const Payment = (props) => {
  const dispatch = useDispatch();

  const { lstMethod } = useSelector((x) => x.payment);

  const { Option } = Select;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isModalEditContractVisible, setIsModalEditContractVisible] =
    useState(false);

  const [titleModal, setTitleModal] = useState("");
  const [valueForm, setValueForm] = useState();

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    getPayment();
    form.setFieldsValue(valueForm);
    // form2.setFieldsValue(valueNote);
  }, [valueForm]);

  const getPayment = () => {
    setLoading(true);
    dispatch(paymentActions.getMethod()).then(() => {
      setLoading(false);
    });
  };

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Logo",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <>
          {image && (
            <Image
              width={100}
              height={100}
              style={{ objectFit: "contain" }}
              src={`${ENV.CDN_URL}${image}`}
              alt="avatar"
            />
          )}
          {!image && (
            <Image
              width={100}
              src="error"
              fallback={ENV.IMAGE_EMPTY}
              alt="avatar"
            />
          )}
        </>
      ),
      width: 350,
      className: "text-center",
    },
    {
      title: "Tên phương thức",
      dataIndex: "name",
    },
    {
      title: "Cổng thanh toán",
      dataIndex: "key",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      render: (active) => (
        <>
          {active === true && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {active === false && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      // fixed: "right",
    },
  ];

  const showEditModal = (record) => {
    setTitleModal("Sửa phương thức");
    setImageNull(record?.image);
    setValueForm({
      name: record.name,
      key: record.key,
      active: record.active,
    });
    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm({});
    form.resetFields();
    setIsModalEditContractVisible(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      updatePayment(values);
    },
    [fileImageUrl]
  );

  const updatePayment = (data) => {
    const payload = {
      "payment-method": {
        key: data.key,
        name: data.name,
        active: data.active,
        image: fileImageUrl,
      },
    };
    console.log(payload);
    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thông tin thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getPayment();
          setIsModalEditContractVisible(false);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  return (
    <>
      <div className="tabled">
        {/* <Card>
          <Row gutter={16}>
            <Col span={24}>
              <label> Tìm theo tên</label>
              <Input
                addonAfter={<SearchOutlined />}
                placeholder="Nhập tên phương thức..."
                // value={inputFilter.name}
                // onChange={(e) => {
                //   setFilter({ ...inputFilter, name: e.target.value });
                // }}
                style={{
                  width: "100%",
                }}
              />
            </Col>
          </Row>
        </Card>

        <br />

        <br /> */}
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.key.toString()}
              loading={loading}
              // onChange={onChange}
              columns={columns}
              dataSource={lstMethod}
              bordered={true}
              className="ant-border-space"
              scroll={{
                x: 1500,
                y: 500,
              }}
            />
          </div>
        </Card>

        <Modal
          title={titleModal}
          visible={isModalEditContractVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueForm}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="key" name="key">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tên phương thức"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập tên!",
                  },
                ]}
              >
                <Input placeholder="Nhập tên ..." />
              </Form.Item>

              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="active"
              >
                <Switch />
              </Form.Item>

              <Form.Item label="Cổng thanh toán" name="key">
                <Input disabled />
              </Form.Item>

              <Form.Item label="Logo">
                <UploadFile />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Payment;
